import { motion } from 'framer-motion';
import { sectionAnimVariants } from '../../../constants/animationVariants';
import { useLanguageContext } from '../../../contexts/LanguageProvider';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import SetupCard from '../../CommonComps/Cards/SetupCard';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import NoTableDataFound from '../../CommonComps/NoTableDataFound';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import CreateLanguageSetupAction from './CreateLanguageSetupAction';
import FilterLanguagesDiv from './FilterLanguagesDiv';

const ShowAllLanguageSetups = () => {
  // integration of context hooks here
  const {
    languageList,
    setShowDeleteModal,
    setTargetedLanguage,
    isError,
    isLoading,
    isSuccess,
  } = useLanguageContext();

  console.log('ADDED LANGUAGES LIST: ', languageList);

  // integration of custom hooks here
  const { featureBasedPermissions } =
    useCheckUserFeaturePermissions('language');

  // rendering show all language setup section component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader
              headerText='All Language setups'
              additionalComponent={
                <CreateLanguageSetupAction
                  hasCreatePermission={
                    featureBasedPermissions
                      ? featureBasedPermissions.includes('CREATE')
                      : false
                  }
                />
              }
            />

            <motion.div
              variants={sectionAnimVariants}
              initial='initial'
              animate='animate'
            >
              <FilterLanguagesDiv />

              {languageList.length ? (
                <div className='grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-5 px-2'>
                  {languageList.map((langSetup) => (
                    <SetupCard
                      key={langSetup.id}
                      title={langSetup.name}
                      label={langSetup.name}
                      deleteBtnTitle='Delete Language Setup'
                      showDeleteModalHandler={
                        featureBasedPermissions.includes('DELETE')
                          ? () => {
                              setTargetedLanguage(langSetup);
                              setShowDeleteModal(true);
                            }
                          : undefined
                      }
                    />
                  ))}
                </div>
              ) : (
                <NoTableDataFound message='No Languages Found!!' />
              )}
            </motion.div>
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='Failed to load language data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllLanguageSetups;
